import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const NaverLoginCallback = () => {
    const { loginWithToken } = useAuth();
    const navigate = useNavigate();
    const hasCalled = useRef(false);

    useEffect(() => {
        if (hasCalled.current) return;
        hasCalled.current = true;

        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const token = params.get('access_token');

        if (token) {
            const inviteCode = sessionStorage.getItem('inviteCode');
            loginWithToken('naver', token, inviteCode);
        } else {
            // No token, maybe user cancelled.
            alert('네이버 로그인을 취소했습니다.');
            navigate('/login', { replace: true });
        }
    }, [loginWithToken, navigate]);

    return <div>네이버 로그인 처리 중...</div>;
};

export default NaverLoginCallback;
